import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi }    from '@angular/common/http';
import { AuthInterceptorService } from './services/API/auth/auth.interceptor';

// Angular Material --> https://material.angular.io
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateAdapter } from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

// Charts --> https://valor-software.com/ng2-charts/#/GeneralInfo --> https://chartjs-plugin-datalabels.netlify.app
import { NgChartsModule } from 'ng2-charts';

// SheetJS --> https://www.npmjs.com/package/xlsx

// DROPZONE --> https://www.npmjs.com/package/ngx-dropzone
import { NgxDropzoneModule } from 'ngx-dropzone';

// SERVICES
import { SocketioService } from './pages/app/shared/services/socketio/socketio.service';

// DATE ADAPTER
import { CustomDateAdapter } from './pages/app/shared/adapters/custom-date-adapter';

// TIME PICKER
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

// Pages
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/app/home/home.component';
import { SettingsComponent } from './pages/app/settings/settings.component';
import { HelpComponent } from './pages/app/help/help.component';
import { LayoutComponent } from './pages/app/layout/layout.component';
import { UserAccountComponent } from './pages/app/settings/subpages/user-account/user-account.component';
import { GestionUsuariosComponent } from './pages/app/settings/subpages/gestion-usuarios/gestion-usuarios.component';
import { AjustesGeneralesComponent } from './pages/app/settings/subpages/ajustes-generales/ajustes-generales.component';
import { BalanzasComponent } from './pages/app/settings/subpages/balanzas/balanzas.component';
import { NewUserComponent } from './pages/app/settings/subpages/gestion-usuarios/components/new-user/new-user.component';
import { ConfirmDialogComponent } from './pages/app/shared/components/confirm-dialog/confirm-dialog.component';
import { AppUpdateFailedDialogComponent } from './pages/app/shared/components/app-update-failed-dialog/app-update-failed-dialog.component';
import { AppUpdateOverlayComponent } from './pages/app/shared/components/app-update-overlay/app-update-overlay.component';
import { EditUserComponent } from './pages/app/settings/subpages/gestion-usuarios/components/edit-user/edit-user.component';
import { EditUserPasswordComponent } from './pages/app/settings/subpages/gestion-usuarios/components/edit-user-password/edit-user-password.component';
import { FilemanagerComponent } from './pages/app/filemanager/filemanager.component';
import { CalendarComponent } from './pages/app/calendar/calendar.component';
import { RecoverComponent } from './pages/login/subpages/recover/recover.component';
import { ChangepasswordComponent } from './pages/login/subpages/changepassword/changepassword.component';
import { NewFolderComponent } from './pages/app/filemanager/components/new-folder/new-folder.component';
import { UploadFileComponent } from './pages/app/filemanager/components/upload-file/upload-file.component';
import { RenameComponent } from './pages/app/filemanager/components/rename/rename.component';
import { CargaComponent } from './pages/app/carga/carga.component';
import { CamionesComponent } from './pages/app/camiones/camiones.component';
import { MaterialesComponent } from './pages/app/materiales/materiales.component';
import { NewCamionComponent } from './pages/app/camiones/components/new-camion/new-camion.component';
import { EditCamionComponent } from './pages/app/camiones/components/edit-camion/edit-camion.component';
import { NewMaterialComponent } from './pages/app/materiales/components/new-material/new-material.component';
import { EditMaterialComponent } from './pages/app/materiales/components/edit-material/edit-material.component';
import { LcdDisplayComponent } from './pages/app/carga/components/lcd-display/lcd-display.component';
import { AdviceComponent } from './pages/app/carga/components/advice/advice.component'; 
import { NewScaleComponent } from './pages/app/settings/subpages/balanzas/components/new-scale/new-scale.component';
import { EditScaleComponent } from './pages/app/settings/subpages/balanzas/components/edit-scale/edit-scale.component';
import { ScaleCropperComponent } from './pages/app/settings/subpages/balanzas/components/scale-cropper/scale-cropper.component';
import { SocketDiagnosticoComponent } from './pages/app/settings/subpages/socket-diagnostico/socket-diagnostico.component';

import { VerRegistrosComponent } from './pages/app/registros/ver-registros/ver-registros.component';
import { RegistroComponent } from './pages/app/registros/ver-registros/subpages/registro/registro.component';
import { ClasificarRegistrosComponent } from './pages/app/registros/clasificar-registros/clasificar-registros.component';
import { ClasificacionComponent } from './pages/app/registros/clasificar-registros/subpages/clasificacion/clasificacion.component';
import { NewRegistroComponent } from './pages/app/registros/clasificar-registros/subpages/clasificacion/components/new-registro/new-registro.component';
import { EditRegistroComponent } from './pages/app/registros/clasificar-registros/subpages/clasificacion/components/edit-registro/edit-registro.component';
import { BuscarRegistrosComponent } from './pages/app/registros/buscar-registros/buscar-registros.component';
import { EditRegistroAdminComponent } from './pages/app/registros/ver-registros/subpages/registro/components/edit-registro-admin/edit-registro-admin.component';
import { EditClasificacionComponent } from './pages/app/registros/ver-registros/subpages/registro/components/edit-clasificacion/edit-clasificacion.component';
import { ContenedoresComponent } from './pages/app/contenedores/contenedores.component';
import { ContenedoresAdmComponent } from './pages/app/contenedores/subpages/contenedores-adm/contenedores-adm.component';
import { ContenedoresMovComponent } from './pages/app/contenedores/subpages/contenedores-mov/contenedores-mov.component';
import { ContenedoresMtnComponent } from './pages/app/contenedores/subpages/contenedores-mtn/contenedores-mtn.component';
import { NewContenedorComponent } from './pages/app/contenedores/subpages/contenedores-adm/components/new-contenedor/new-contenedor.component';
import { ContenedoresTiposComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/contenedores-tipos/contenedores-tipos.component';
import { NewTipoComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/contenedores-tipos/components/new-tipo/new-tipo.component';
import { EditTipoComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/contenedores-tipos/components/edit-tipo/edit-tipo.component';
import { ViewContenedorComponent } from './pages/app/contenedores/subpages/contenedores-adm/subpages/view-contenedor/view-contenedor.component';
import { ViewMovimientosComponent } from './pages/app/contenedores/subpages/shared/view-movimientos/view-movimientos.component';
import { ViewMantenimintosComponent } from './pages/app/contenedores/subpages/shared/view-mantenimintos/view-mantenimintos.component';
import { NewMantenimientoComponent } from './pages/app/contenedores/subpages/shared/components/mantenimientos/new-mantenimiento/new-mantenimiento.component';
import { NewMovimientoComponent } from './pages/app/contenedores/subpages/shared/components/movimientos/new-movimiento/new-movimiento.component';
import { EditMovimientoComponent } from './pages/app/contenedores/subpages/shared/components/movimientos/edit-movimiento/edit-movimiento.component';
import { EditMantenimientoComponent } from './pages/app/contenedores/subpages/shared/components/mantenimientos/edit-mantenimiento/edit-mantenimiento.component';
import { GpsLocatorComponent } from './pages/app/contenedores/subpages/shared/components/movimientos/shared/gps-locator/gps-locator.component';
import { GalleryComponent } from './pages/app/contenedores/subpages/shared/components/shared/gallery-system/gallery/gallery.component';
import { UploadImagesComponent } from './pages/app/contenedores/subpages/shared/components/shared/gallery-system/upload-images/upload-images.component';
import { ViewFotoComponent } from './pages/app/contenedores/subpages/shared/components/shared/gallery-system/view-foto/view-foto.component';

// Components
@NgModule({ declarations: [
        AppComponent,
        LayoutComponent,
        LoginComponent,
        HomeComponent,
        SettingsComponent,
        HelpComponent,
        UserAccountComponent,
        GestionUsuariosComponent,
        AjustesGeneralesComponent,
        BalanzasComponent,
        NewUserComponent,
        ConfirmDialogComponent,
        AppUpdateFailedDialogComponent,
        AppUpdateOverlayComponent,
        EditUserComponent,
        EditUserPasswordComponent,
        FilemanagerComponent,
        CalendarComponent,
        RecoverComponent,
        ChangepasswordComponent,
        NewFolderComponent,
        UploadFileComponent,
        RenameComponent,
        CargaComponent,
        CamionesComponent,
        MaterialesComponent,
        NewCamionComponent,
        EditCamionComponent,
        NewMaterialComponent,
        EditMaterialComponent,
        LcdDisplayComponent,
        RegistroComponent,
        ClasificacionComponent,
        NewRegistroComponent,
        EditRegistroComponent,
        EditRegistroAdminComponent,
        EditClasificacionComponent,
        AdviceComponent,
        NewScaleComponent,
        EditScaleComponent,
        ScaleCropperComponent,
        SocketDiagnosticoComponent,
        VerRegistrosComponent,
        ClasificarRegistrosComponent,
        BuscarRegistrosComponent,
        ContenedoresComponent,
        ContenedoresAdmComponent,
        ContenedoresMovComponent,
        ContenedoresMtnComponent,
        NewContenedorComponent,
        ContenedoresTiposComponent,
        NewTipoComponent,
        EditTipoComponent,
        ViewContenedorComponent,
        ViewMovimientosComponent,
        ViewMantenimintosComponent,
        NewMantenimientoComponent,
        NewMovimientoComponent,
        EditMovimientoComponent,
        EditMantenimientoComponent,
        GpsLocatorComponent,
        GalleryComponent,
        UploadImagesComponent,
        ViewFotoComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        NgChartsModule,
        MatToolbarModule,
        FormsModule,
        ReactiveFormsModule,
        MatTreeModule,
        MatTooltipModule,
        MatNativeDateModule,
        NgxDropzoneModule,
        NgxMaterialTimepickerModule,
    ], providers: [
        SocketioService,
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic', appearance: 'outline' }
        },
        // Keep Material overlays out of the browser top layer so third-party popups
        // (ngx-material-timepicker) can stack above MatDialog again.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        MatDatepickerModule,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
